import { spaceAPI } from '@/api';
import CommonSpaceListContainer from '@/components/common/CommonSpaceListContainer';
import ResomHeader from './ResomHeader';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';

interface DataType {
  id: number;
  title: string;
  description: string;
  address: string;
  address_lat: string;
  address_long: string;
  category: string;
  floor_default: string | null;
  img: string;
  link: string;
  phone: string;
  thumbnail: string | null;
  time: string;
  type: string;
  updatedAt: string;
  use_app: boolean;
}

  const columnHelper = createColumnHelper<DataType>();

const categoryMap: { [key: string]: string } = {
  '11': '객실',
  '12': 'F&B',
  '13': '스파',
  '7': '테마정원',
  '14': '연회장',
  '15': '부대시설',
};

const typeMap: { [key: string]: string } = {
  resom_restree: '레스트리',
  resom_forestclub: '포레스트클럽',
  resom_outside: '야외',
  };

const getColumns = (): ColumnDef<DataType, any>[] => {
    const baseColumns = [
      columnHelper.accessor('id', {
        header: 'ID',
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor('title', {
        header: '이름',
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor('description', {
        header: '설명',
        cell: (info) => {
          const text = info.getValue();
          return text.length > 10 ? `${text.slice(0, 10)}...` : text;
        },
      }),
      columnHelper.accessor('category', {
        header: '카테고리',
      cell: (info) => categoryMap[info.getValue()] || info.getValue(),
      }),
      columnHelper.accessor('type', {
        header: '타입',
      cell: (info) => typeMap[info.getValue()] || info.getValue(),
      }),
      columnHelper.accessor('use_app', {
        header: '앱 사용 여부',
        cell: (info) => (info.getValue() ? '사용' : '미사용'),
      }),
      columnHelper.accessor('updatedAt', {
        header: '수정일',
        cell: (info) => new Date(info.getValue()).toLocaleDateString(),
      }),
    ];

    return baseColumns.filter(Boolean) as ColumnDef<DataType, any>[];
};

const ResomContainer = () => {
  const handleCreate = () => {
    const confirm = window.confirm('공간을 추가로 생성합니다.');
    if (confirm) {
      spaceAPI
        .createSpaceResom({
          code: import.meta.env.VITE_SECRET_API_KEY,
        })
        .then((res) => {
          if (res.status === 200) {
            alert(`공간이 생성되었습니다.\nid: ${res.data.id}`);
            window.location.href = `/resom/space/${res.data.id}`;
          } else {
            alert('공간 생성에 실패했습니다.');
          }
        });
    }
  };

  const handleDelete = async (selectedIds: number[]) => {
    return spaceAPI.deleteSpaceResom(
        {
          code: import.meta.env.VITE_SECRET_API_KEY,
        },
      { ids: selectedIds }
    );
  };

  return (
    <CommonSpaceListContainer<DataType>
      HeaderComponent={ResomHeader}
      queryKey="getSpacesResom"
      queryFn={() =>
        spaceAPI.getSpacesResom({
          code: import.meta.env.VITE_SECRET_API_KEY,
        })
      }
      columns={getColumns}
      baseRoute="/resom/space"
      buttonColor="resom"
      onDelete={handleDelete}
      onCreate={handleCreate}
      showCreateButton={true}
    />
  );
};

export default ResomContainer;
